import PropTypes from 'prop-types';
import React__default, { useRef } from 'react';
import { PopoverContentInternal } from '../popover/popover-content-internal.component.js';
import { PopoverDialog } from '../popover/popover-dialog.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { useSwanPopover } from '../popover/popover.context.js';
import { useIsomorphicLayoutEffect } from '../../hooks/use-isomorphic-layout-effect.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
({
    inModal: PropTypes.bool
});
const ListboxPopover = renderWithRef('ListboxPopover', {}, (props, ref)=>{
    const { children , className , isNonModal  } = props;
    const { overlayState , triggerRef , fullWidth  } = useSwanPopover();
    const popoverRef = useRef(null);
    const combinedRef = assignRefs(ref, popoverRef);
    const classes = new Set([
        'swan-listbox-popover'
    ]);
    if (className) classes.add(className);
    useIsomorphicLayoutEffect(()=>{
        const popoverEl = popoverRef.current;
        const triggerEl = triggerRef.current;
        if (overlayState.isOpen && fullWidth && triggerEl && popoverEl) {
            const { width  } = triggerEl.getBoundingClientRect();
            popoverEl.style.width = `${width}px`;
            popoverEl.style.minWidth = `${width}px`;
            popoverEl.style.maxWidth = `${width}px`;
        }
    }, [
        overlayState.isOpen,
        fullWidth,
        triggerRef
    ]);
    return overlayState.isOpen ? /*#__PURE__*/ React__default.createElement(PopoverContentInternal, _object_spread_props(_object_spread({}, props), {
        ref: combinedRef,
        className: [
            ...classes
        ].join(' ')
    }), isNonModal ? /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, children) : /*#__PURE__*/ React__default.createElement(PopoverDialog, null, children)) : /* the listbox list needs to be rendered in the dom for the items to be registered with the parent listbox */ /*#__PURE__*/ React__default.createElement("div", {
        "aria-hidden": "true",
        className: "swan-display-none"
    }, children);
});
ListboxPopover.defaultProps = {
    placement: 'bottom start',
    hideArrow: true
};

export { ListboxPopover };
